import React from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box } from '@mui/material';

const DynamicDropdownIcon = ({ 
  isOpen, 
  textColor, 
  size = 20,
  isHovered = false,
  hoverTextColor
}) => {
  const iconColor = isHovered ? hoverTextColor : textColor;
  
  return (
    <Box sx={{ 
      color: iconColor,
      '& .MuiSvgIcon-root': {
        color: iconColor,
      },
      '& svg': {
        color: iconColor,
        fill: iconColor,
      }
    }}>
      {isOpen ? (
        <ExpandLess 
          style={{ 
            width: size, 
            height: size, 
            color: iconColor,
            fill: iconColor
          }} 
        />
      ) : (
        <ExpandMore 
          style={{ 
            width: size, 
            height: size, 
            color: iconColor,
            fill: iconColor
          }} 
        />
      )}
    </Box>
  );
};

export default DynamicDropdownIcon;
